<template>
<!--  v-on:click="checkModule" -->
    <div class="com-item" v-if="type == 'preview'" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" v-if="modata.WContent.Height" :style="{backgroundColor:modata.WContent.BgColor,height:(modata.WContent.Height*proportion)+'px'}"></div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'space-module',
        props: {
            type: {         //展示类型 preview预览模块 setting设置模块
                type: String,
                default: 'preview'
            },
            index: {        //索引
                type: Number
            },
             proportion: {
                type: Number,
                default:1,
            },

            modata: {
                type: Object,
                // 对象或数组默认值必须从一个工厂函数获取
                default: function () {
                    return {
                        WName: 'space',
                        Title: '空白占位',
                        WID: 1,
                        ModuleName: 'space-module',
                        WContent: {},
                    }
                }
            }
        },
        data() {
            return {
                activeName: ['1', '2',],
                activeIndex:0,
                rootValue:this.$store.state.rootValue||1,
            }
        },
        mounted() {
         this.modata.WContent.Height=this.modata.WContent.Height?parseInt(this.modata.WContent.Height):0;

        },
        beforeDestroy() {

        },
        methods: {


        },
        watch: {
         
        },
        
    }

</script>
<style>
/**设置 */

  


</style>
